<template>
  <div class="main-page">
    <div class="logo-center">
      <img src="/logo.png" alt="" class="logo">
    </div>
  </div>
</template>

<script>
export default {
  name: "mainPage"
};
</script>

<style src='./MainPage.scss' lang="scss"></style>
